import styled from 'styled-components';
import {
  inlineFlexbox,
  alignItems,
  justifyContent,
  flexbox
} from '../../styles/helpers/flexbox';

const LegendWrapper = styled.span((props) => {
  const { palette } = props.theme;
  return `
    position: absolute;
    margin-top: 10px;
    right: -40px;
    padding: 0 10px 10px;
    min-width: 200px;
    background-color: white;
    z-index: 9;
    box-shadow: 4px 2px 6px;
    border-radius: 4px;
    font-size: 14px;
  
    [class*='svgIconComponent--'] {
      height: 24px !important;
    }
  
    .item {
      ${inlineFlexbox()};
      ${alignItems('center')};
  
      margin-bottom: 10px;
      background-color: #f4f9f1;
      border-radius: 5px;
      padding: 4px;
      width: 97%;
    }
  
    ::after {
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 15px solid #fff;
      position: absolute;
      top: -15px;
      right: 95px;
      content: ' ';
      z-index: 9;
    }
  
    .headerText {
      color: #000000;
      font-weight: 700;
      margin-bottom: -15px;
    }
  
    & div[class*='ButtonWrapper'] {
      height: 40px;
      &:first-of-type { 
        margin-right: 20px;
        color: white;
        padding: 15px;
        background-color: ${palette.secondary.main};
      }
    }
  `;
});

const Title = styled.div`
  font-size: 14px;
  margin: 20px 0 0;
  color: #3b4e5d;
  height: 25px;
  line-height: 16px;
  padding-bottom: 10px;
  &:first-of-type {
    padding-bottom: 0;
  }
`;

const ColorBlock = styled.div(
  (props) => `
    ${inlineFlexbox()};
    ${justifyContent('center')};
    ${alignItems('center')};

    width: 23px;
    height: 23px;
    background-color: ${props.color};
    border: 1px solid #cfd2d4;

    margin: 0 10px;

    .icon {
      width: 15px;
    }
`
);

const Results = styled.div`
  margin: 10px 0;
`;

const CheckboxWrapper = styled.span`
  ${flexbox()};
  ${justifyContent('center')};
  ${alignItems('center')};

  height: 100%;
`;

const DateRange = styled.div`
  [class*='-DropdownMenuWrapper'] {
    width: 98%;
  }
`;

const ButtonWrapper = styled.div`
  ${flexbox()}
  ${justifyContent('center')};
  width: 100px;
  margin: 8px auto 5px;

  * {
    font-size: inherit !important;
    text-indent: initial !important;
  }
`;

const Clear = styled.div`
  text-align: right;
  padding: 2px 5px 0 0;
  margin-bottom: -10px;
  cursor: pointer;
  text-decoration: underline;
`;

export {
  LegendWrapper,
  ColorBlock,
  Title,
  Results,
  CheckboxWrapper,
  DateRange,
  ButtonWrapper,
  Clear
};



// WEBPACK FOOTER //
// ./components/legend/styled.js